"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getAssetsFromMap;

function assetExists(a) {
  return null === a || a;
}

function getAssetsFromMap(a, b) {
  return b ? b.map(function (b) {
    return a.get(b);
  }).filter(assetExists) : Array.from(a.values()).filter(assetExists);
}